module.exports = __webpack_public_path__ + "img/arrow-up.9f5b70af.svg";